import { useAPIEventActions } from '@fullstory/redux';
import React, { useState } from 'react';
import { APIEventModal } from '../../components';
import { APIEvent } from '../../data-mgmt';

const CLOSED = 'CLOSED';
type ModalInput = APIEvent | typeof CLOSED;

interface APIEventModalContainerProps {
  modalInput: ModalInput;
  setModalInput: (modalInput: ModalInput) => void;
}

const APIEventModalContainer: React.FC<APIEventModalContainerProps> = ({
  modalInput,
  setModalInput,
}) => {
  const { saveEvent, archiveEvent, unarchiveEvent } = useAPIEventActions();

  if (modalInput === CLOSED) {
    return null;
  }

  return (
    <APIEventModal
      data-component="APIEventModalContainer"
      apiEvent={modalInput}
      onSave={saveEvent}
      onArchive={archiveEvent}
      onUnarchive={unarchiveEvent}
      onCloseSignal={() => setModalInput(CLOSED)}
    />
  );
};

export const useAPIEventModal = () => {
  const [modalInput, setModalInput] = useState<ModalInput>(CLOSED);

  const apiEventModalProps = {
    modalInput,
    setModalInput,
  };

  const APIEventModalComponent = <APIEventModalContainer {...apiEventModalProps} />;

  return {
    ...apiEventModalProps,
    APIEventModalComponent,
  };
};
